import { render, staticRenderFns } from "./BridgeTransferSection.vue?vue&type=template&id=662dc9fa&scoped=true"
import script from "./BridgeTransferSection.vue?vue&type=script&lang=ts"
export * from "./BridgeTransferSection.vue?vue&type=script&lang=ts"
import style0 from "./BridgeTransferSection.vue?vue&type=style&index=0&id=662dc9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662dc9fa",
  null
  
)

export default component.exports